/** "By when": 1, 3, 6 or 12 months from the review meeting. */

export const TIMEFRAMES: { value: string; label: string; hint: string }[] = [
  { value: "1m", label: "1 month", hint: "A quick win" },
  { value: "3m", label: "3 months", hint: "Short term" },
  { value: "6m", label: "6 months", hint: "Medium term" },
  { value: "12m", label: "12 months", hint: "By next year's appraisal" },
];

export function timeframeLabel(value: string | null | undefined): string {
  return TIMEFRAMES.find((t) => t.value === value)?.label ?? "";
}

export default function TimeframePicker({
  value,
  onChange,
  disabled,
  label = "By when",
}: {
  value: string | null | undefined;
  onChange: (value: string) => void;
  disabled?: boolean;
  label?: string;
}) {
  return (
    <div>
      <span className="mb-1 block text-xs font-medium text-gray-600">{label}</span>
      <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-1.5">
        {TIMEFRAMES.map((t) => {
          const on = value === t.value;
          return (
            <button
              key={t.value}
              type="button"
              role="radio"
              aria-checked={on}
              disabled={disabled}
              onClick={() => onChange(on ? "" : t.value)}
              title={t.hint}
              className={`min-h-[36px] rounded-full border px-3 text-xs font-semibold transition-colors disabled:opacity-60 ${
                on ? "border-purple-600 bg-purple-600 text-white" : "border-gray-200 bg-white text-gray-600 hover:border-purple-300"
              }`}
            >
              {t.label}
            </button>
          );
        })}
      </div>
      <p className="mt-1 text-[11px] text-gray-500">Counted from the review meeting.</p>
    </div>
  );
}
